import {Typography} from "@mui/material";

export const Heading = ({children}) =>
	<Typography align={"center"} variant={"h3"}>
		{children}
	</Typography>
